import * as types from '../constants/action-types';

const initialState = {
  data: {},
  error: null,
  isPosting: false,
  isFetching: false
};

export default function contractReducer (state = initialState, action) {
  const { data, error, isPosting, isFetching } = action;

  switch (action.type) {
  case types.OFFER_QUOTE_CREATE_REQUEST:
  case types.OFFER_CREATE_REQUEST:
  case types.OFFER_WITHDRAW_REQUEST:
  case types.OFFER_ACCEPT_REQUEST:
  case types.OFFER_DECLINE_REQUEST:
  case types.HOST_UPDATE_DECLINE_REQUEST:
  case types.HOST_UPDATE_ACCEPT_REQUEST:
  case types.HOST_UPDATE_CREATE_REQUEST:
  case types.HOST_UPDATE_QUOTE_REQUEST:
  case types.GUEST_UPDATE_QUOTE_REQUEST:
  case types.CANCEL_BOOKING_QUOTE_REQUEST:
  case types.FETCH_CANCELLATION_CONTRACTS_REQUEST:
  case types.OVERTIME_QUOTE_REQUEST:
  case types.CREATE_OVERTIME_REQUEST:
    return {
      ...state,
      isPosting,
      error: null
    };

  case types.OFFER_QUOTE_CREATE_SUCCESS:
  case types.OFFER_CREATE_SUCCESS:
  case types.HOST_UPDATE_QUOTE_SUCCESS:
  case types.HOST_UPDATE_CREATE_SUCCESS:
  case types.OVERTIME_QUOTE_SUCCESS:
  case types.CREATE_OVERTIME_SUCCESS:
    return {
      ...state,
      quote: data,
      isPosting
    };

  case types.GUEST_UPDATE_QUOTE_SUCCESS: {
    const quoteErrors = data?.body?.body?.errors;
    if (quoteErrors) {
      // don't overwrite existing quote data if there are errors
      return {
        ...state,
        quoteErrors,
        isPosting
      };
    }
    return {
      ...state,
      quote: data,
      quoteErrors: [],
      isPosting
    };
  }
  case types.OFFER_WITHDRAW_SUCCESS:
  case types.OFFER_ACCEPT_SUCCESS:
  case types.OFFER_DECLINE_SUCCESS:
  case types.HOST_UPDATE_DECLINE_SUCCESS:
  case types.HOST_UPDATE_ACCEPT_SUCCESS:
    return {
      ...state
    };

  case types.OFFER_QUOTE_CREATE_FAILURE:
  case types.OFFER_CREATE_FAILURE:
  case types.OFFER_WITHDRAW_FAILURE:
  case types.OFFER_ACCEPT_FAILURE:
  case types.OFFER_DECLINE_FAILURE:
  case types.CONTRACTS_FETCH_FAILURE:
  case types.HOST_UPDATE_CREATE_FAILURE:
  case types.HOST_UPDATE_QUOTE_FAILURE:
  case types.HOST_UPDATE_DECLINE_FAILURE:
  case types.HOST_UPDATE_ACCEPT_FAILURE:
  case types.CONTRACTS_SNAPSHOT_FETCH_FAILURE:
  case types.GUEST_UPDATE_QUOTE_FAILURE:
  case types.CANCEL_BOOKING_QUOTE_FAILURE:
  case types.FETCH_CANCELLATION_CONTRACTS_FAILURE:
  case types.OVERTIME_QUOTE_FAILURE:
  case types.CREATE_OVERTIME_FAILURE:
    return {
      ...state,
      isPosting,
      isFetching,
      error
    };

  case types.CONTRACTS_FETCH_REQUEST:
  case types.CONTRACTS_SNAPSHOT_FETCH_REQUEST:
    return {
      ...state,
      isFetching
    };

  case types.CONTRACTS_FETCH_SUCCESS:
    return {
      ...state,
      contracts: data.contracts,
      outstanding_balance: data.outstanding_balance
    };

  case types.CONTRACTS_SNAPSHOT_FETCH_SUCCESS:
    return {
      ...state,
      data
    };

  case types.FETCH_CANCELLATION_CONTRACTS_SUCCESS:
    return {
      ...state,
      cancellationObj: data
    };

  case types.CANCEL_BOOKING_QUOTE_SUCCESS:
    return {
      ...state,
      isPosting: false,
      cancelContractObj: data
    };

  case types.RESET_CONTRACT_STORE:
    return initialState;

  default:
    return state;
  }
}
